import React, { Component } from 'react';
import { connect } from 'react-redux';
import './form.css';

class contractForm extends Component {
  constructor(props) {
    super(props);
    // State is in reducers
    this.state = {
     
    };

  }

  onChangeName = (event) =>{
    var tmpData = {...this.props.data};
    tmpData.name = event.target.value;
    tmpData.type = "CONTRACT";
    this.props.onUpdateData(tmpData);
  }


  render() {
    var data = this.props.data;
    if(data === null){
      data = {type:"CONTRACT",name:""};
    }

    return (
      <div className="form-container" >
        <div className="form-section">
          <div className="section-header">
            <span className="section-name">Identification</span>
            <div className="section-status unvalid"></div>
          </div>
          <div className="section-item">
            <label>Name</label>
            <input type="text" onChange={this.onChangeName.bind()} value={data.name}></input>
          </div>
          <div className="section-item">
            <label>Type</label>
            <input type="text"></input>
          </div>
          <div className="section-item">
            <label>Numero d'identification</label>
            <input type="text"></input>
          </div>
        </div>
        <div className="form-section">
            <div className="section-header">
              <span className="section-name">Limites</span>
              <div className="section-status unvalid"></div>
            </div>
            <div className="section-item">
              <label>Limite 1</label>
              <input type="text"></input>
            </div>
            <div className="section-item">
              <label>Limite 2</label>
              <input type="text"></input>
            </div>
            <div className="section-item">
              <label>Valeur 1</label>
              <input type="text"></input>
            </div>
          </div>
      </div>
    );
  }
}

  const mapStateToProps = (state) => {    
    return {  
    } 
  }
  const mapDispatchToProps = (dispatch) => {
    return {
    } 
  } 
  
  export default connect(mapStateToProps, mapDispatchToProps)(contractForm);